/**
 * Script / Checkout: Checkout accordion
 * ----------------------------------------------------------------------------
 * Accordion script.
 *
 * @namespace checkoutAccordion
 */
import cssClasses from '~/config/classes'

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-accordion="container"]',
  item: '[js-accordion="item"]',
  control: '[js-accordion="control"]',
}

/**
 * Create a new address lookup object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    items: document.querySelectorAll(selectors.item),
    controls: document.querySelectorAll(selectors.control),
  }

  /**
   * Initialise.
   */
  function init() {
    if (!nodeSelectors.container) {
      return
    }

    setEventListeners()
  }

  /**
   * Set EventBus event listeners.
   */
  function setEventListeners() {
    handleAccordion()
  }

  /**
   * Handle accordion.
   */
  function handleAccordion() {
    nodeSelectors.controls.forEach(control => {
      control.addEventListener('click', () => {
        const item = control.closest(selectors.item)

        if (item.classList.contains(cssClasses.active)) {
          control.setAttribute('aria-expanded', 'true')
          item.classList.remove(cssClasses.active)

        } else {
          document.querySelector('.checkout-accordion__item.is-active')?.classList.remove(cssClasses.active)
          control.setAttribute('aria-expanded', 'false')
          item.classList.add(cssClasses.active)
        }
      })
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
